import { render, staticRenderFns } from "./Notification_Editeur.vue?vue&type=template&id=02908f1b&scoped=true&"
import script from "./Notification_Editeur.vue?vue&type=script&lang=js&"
export * from "./Notification_Editeur.vue?vue&type=script&lang=js&"
import style0 from "./Notification_Editeur.vue?vue&type=style&index=0&id=02908f1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02908f1b",
  null
  
)

export default component.exports